import React, { useState } from "react";
import { View } from "react-native";
import { styles } from "./Panel.styles";
import { SmallBrandPattern, LargeBrandPattern, SmallAccentPattern, LargeAccentPattern, SmallWarningPattern, } from "./Patterns";
const patternComps = {
    smallBrandPattern: SmallBrandPattern,
    largeBrandPattern: LargeBrandPattern,
    smallAccentPattern: SmallAccentPattern,
    largeAccentPattern: LargeAccentPattern,
    smallWarningPattern: SmallWarningPattern,
};
export const Panel = ({ color = "light", shadow = true, rounded = true, styles: userStyles, children, pattern, testID, ...rest }) => {
    /**
     * Panel width and heigh are calculated, and these dimensions are then
     * passed to the pattern component. The pattern will then be rendered to
     * the dimensions of the panel plus some extra to account for edges.
     */
    const [panelWidth, setPanelWidth] = useState(0);
    const [panelHeight, setPanelHeight] = useState(0);
    const capitalizedColor = color.charAt(0).toUpperCase() + color.slice(1);
    const patternCompKey = pattern ? `${pattern}${capitalizedColor}Pattern` : "";
    const PatternComp = patternComps[patternCompKey];
    return (React.createElement(React.Fragment, null,
        React.createElement(View, { ...rest, onLayout: (event) => {
                const { width, height } = event.nativeEvent.layout;
                setPanelHeight(height);
                setPanelWidth(width);
            }, style: [
                styles.defaults,
                styles[color],
                shadow && styles["shadow"],
                rounded && styles["rounded"],
                userStyles,
            ], testID: testID },
            PatternComp && (React.createElement(PatternComp, { patternWidth: panelWidth, patternHeight: panelHeight })),
            children)));
};
//# sourceMappingURL=Panel.js.map